import { useState, useEffect, useMemo } from 'react'
import { Fetch } from 'customer/function/Fetch'
import { format, addDays, isWeekend, closestTo } from 'date-fns'

type FairDate = {
  id: string
  date: string
}

// フェアのある日付と直帰の土日の中で一番近い日付を取得するhooks
export const useDates = ({
  pageKey,
}: {
  pageKey: string
}): {
  dates: Date[] | undefined
  initialDate: Date | undefined
} => {
  const [dates, setDates] = useState<Date[] | undefined>(undefined)
  useEffect(() => {
    ;(async () => {
      const url = `/customer/api/v1/fair_dates?page_key=${pageKey}&start_date=${format(
        new Date(),
        'yyyy-MM-dd',
      )}$end_date=${format(addDays(new Date(), 100), 'yyyy-MM-dd')}`
      const res = await Fetch(url, 'GET', {})
      const json = (await res.json()) as { fairDates: FairDate[] }
      setDates(Array.from(new Set(json.fairDates.map((fairDate) => new Date(fairDate.date)))))
    })()
  }, [pageKey])

  const initialDate = useMemo(() => {
    if (!dates) return undefined
    const weekendDates = dates.filter((date) => isWeekend(date))
    if (weekendDates.length === 0) return undefined
    const now = new Date()
    return closestTo(now, weekendDates)
  }, [dates])

  return {
    dates,
    initialDate,
  }
}
